import NumberFormatter from '../../NumberFormatter';
import ReportQuery from './ReportQuery';

export default class MortgageTrait {

    constructor(target) {

        if (typeof (target) != 'object')
            throw new Error('Target param must be object');

        this.target = target;

        target.getReportQuery = this.getReportQuery.bind(this);
        target.updateReportQuery = this.updateReportQuery.bind(this);
    }

    getActiveTabId() {
        
        return this.target.nodes.form.closest('[data-role="tab"]').dataset.id;
    }

    readCheckedFromInput(name) {

        return this.target.nodes.form.querySelector(`[name="${name}"]:checked`)?.value;
    }

    readAnyFromInput(name) {

        return this.target.nodes.form.querySelector(`[name="${name}"]`)?.value;
    }

    readFloatFromInput(name) {

        const value = this.readAnyFromInput(name);
        if (!value)
            return null;

        return NumberFormatter
            .parse(value)
            .toFloat();
    }
    
    getReportQuery() {

        return this.updateReportQuery();
    }

    updateReportQuery() {

        if (this.reportQuery == undefined)
            this.reportQuery = new ReportQuery(this.target.props.query ?? {});

        this.reportQuery.options.tab = this.getActiveTabId();
        this.reportQuery.options.sum = this.readFloatFromInput('price');
        this.reportQuery.options.creditSum = this.readFloatFromInput('credit_sum');
        this.reportQuery.options.initFee = {
            value: this.readFloatFromInput('initial_fee-value'),
            unit: this.readAnyFromInput('initial_fee-unit'),
        };
        this.reportQuery.options.term = this.readFloatFromInput('credit_term');
        this.reportQuery.options.rate =  this.readFloatFromInput('credit_rate');
        this.reportQuery.options.creditType = this.readCheckedFromInput('credit_type');

        return this.reportQuery;
    }

}